module.exports = __webpack_public_path__ + "img/plan-1-2.193efaab.png";